<template>
  <div class="form-group" v-show="showOption">
    <template v-if="showOption">
      <label class="custom-label">{{ $t('ct-sticky-header') }}</label>
      <div class="form">
        <label style="width: 250px;">
          <input type="checkbox" v-model="fixedActive" @change="changeValue" @keyup="changeValue">
          {{ $t('ct-active-desktop') }}
        </label>
        <label style="width: 250px;">
          <input type="checkbox" v-model="fixedMobileActive" @change="changeValue" @keyup="changeValue">
          {{ $t('ct-active-mobile') }}
        </label>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'FixedComponent',
  data() {
    return {
      element: null,
      fixedActive: false,
      fixedMobileActive: false,
      labelDesc: 'opa',
      callback: null,
      showOption: false
    };
  },
  methods: {
    changeValue() {
      this.callback();
    },
    async setValues(obj, el) {
      let layoutItem = document.querySelector('.editor-content-item-layout > .sitebuilder-element-panel');

      if (this.$route.params.type && this.$route.params.type === 'footer') {
        this.showOption = false;
      } else {
        var vm = this;
        var promise = new Promise(
          function(resolve, reject) {
            vm.$root.$emit('getFirstElement', resolve);
          });

        promise.then((element) => {
          if (element) { vm.showOption = (layoutItem) ? false : el.id === element.id }
        }).catch((e) => console.error('e', e));
      }

      this.fixedActive = obj.fixed;
      this.fixedMobileActive = obj.fixedMobile;
      this.element = obj.element;
      this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
      this.callback = obj.callback;
    }
  }
};
</script>
<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/Fixed.vue